import { HeatingSytem, HvacType, ReversingValve, SystemType, } from '../types/Gateway';
import { global, isDefined } from './../utils';
function getHvacTypeFromSystemType(systemType) {
    switch (systemType) {
        case SystemType.HP_SINGLE_STAGE_COOL_ONLY:
            return HvacType.HP_SINGLE_STAGE_COOL_ONLY;
        case SystemType.HP_SINGLE_STAGE_HEAT_ONLY:
            return HvacType.HP_SINGLE_STAGE_HEAT_ONLY;
        case SystemType.HP_SINGLE_STAGE_COOL_HEAT:
            return HvacType.HP_SINGLE_STAGE_COOL_HEAT;
        case SystemType.HP_TWO_STAGE_COOL_ONLY:
            return HvacType.HP_TWO_STAGE_COOL_ONLY;
        case SystemType.HP_TWO_STAGE_HEAT_ONLY:
            return HvacType.HP_TWO_STAGE_HEAT_ONLY;
        case SystemType.HP_TWO_STAGE_COOL_HEAT:
            return HvacType.HP_TWO_STAGE_COOL_HEAT;
        case SystemType.CS_TWO_STAGE_COOL_ONLY:
            return HvacType.CS_TWO_STAGE_COOL_ONLY;
        case SystemType.CS_TWO_STAGE_HEAT_ONLY:
            return HvacType.CS_TWO_STAGE_HEAT_ONLY;
        case SystemType.CS_TWO_STAGE_COOL_HEAT:
            return HvacType.CS_TWO_STAGE_COOL_HEAT;
        case SystemType.CS_SINGLE_STAGE_COOL_HEAT:
            return HvacType.CS_SINGLE_STAGE_COOL_HEAT;
        case SystemType.CS_SINGLE_STAGE_COOL_ONLY:
            return HvacType.CS_SINGLE_STAGE_COOL_ONLY;
        case SystemType.CS_SINGLE_STAGE_HEAT_ONLY:
            return HvacType.CS_SINGLE_STAGE_HEAT_ONLY;
        default:
            return undefined; // Handle unknown systemType if necessary
    }
}
export function getHvacTypeLabelFromHvacType(systemType) {
    return HvacType[systemType];
}
export const isEBHeatPumpSystem = (systemType) => {
    if (isDefined(systemType)) {
        const hvacType = getHvacTypeFromSystemType(systemType);
        const isHeatPump = hvacType
            ? hvacType === HvacType.HP_HEAT_ONLY ||
                hvacType === HvacType.HP_COOL_ONLY ||
                hvacType === HvacType.TWO_STAGE_HEAT ||
                hvacType === HvacType.SINGLE_STAGE_COOL_HEAT ||
                hvacType === HvacType.TWO_STAGE_COOL_HEAT
            : false;
        return isHeatPump;
    }
    return false;
};
/**
 * Process the response from a gateway or control board to determine HVAC type.
 * @param {Gateway | ControlBoard} gateway - The gateway or control board object.
 * @returns {HvacType | String} The determined HVAC type or NOT_AVAILABLE if unknown.
 * For Venstar -  HVAC TYPE:
    HPSwitch: 0=Heatpump 1=Gas/Elec (refer to gasElecSwtich)
    gasElecSwtich: 0=Electric 1=Gas
   For EB thermostat - HVAC TYPE:
    Determined from System Type having 7 values
 */
export const processGatewayApiResponse = (gateway) => {
    // Check for cases where the entity is 'EnergyboxThermostat'
    if (gateway._entity === 'EnergyboxThermostat') {
        if (isDefined(gateway.systemType)) {
            return (getHvacTypeFromSystemType(gateway.systemType) || global.NOT_AVAILABLE);
        }
        return global.NOT_AVAILABLE;
    }
    // Check if the hpSwitch indicates a heat pump
    if (gateway.hpSwitch === 0)
        return HvacType.HEAT_PUMP;
    if (gateway.hpSwitch === 1) {
        // Check for electric HVAC
        if (gateway.gasElecSwitch === 0) {
            return HvacType.ELECTRIC;
        }
        // Check for gas HVAC
        if (gateway.gasElecSwitch === 1) {
            return HvacType.GAS;
        }
    }
    // Return NOT_AVAILABLE for unknown cases
    return global.NOT_AVAILABLE;
};
/**REVERSING VALVE:
invertObSwtich (only relevant for Heatpump):  0=Reversing Valve B / 1=Reversing Valve O
valveLogic (only relevant for RFStat + Heatpump):  0=Reversing Valve O / 1=Reversing Valve B
 */
export const processGatewayDipSwitch = (gateway) => {
    if (gateway._entity === 'EnergyboxThermostat') {
        if (gateway.valveLogic == 0) {
            return ReversingValve.REVERSING_VALVE_O;
        }
        if (gateway.valveLogic === 1) {
            return ReversingValve.REVERSING_VALVE_B;
        }
        return global.NOT_AVAILABLE;
    }
    else {
        if (gateway.invertObSwitch === 0)
            return ReversingValve.REVERSING_VALVE_B;
        return ReversingValve.REVERSING_VALVE_O;
    }
};
/**HEATING_SYSTEM VALVE:
gasSytem (only relevant for Conventional):  gas_system = true then Heating System : “Gas”
gas_system = false then Heating System : “Electric”
 */
export const processGatewayHeatingSystem = (gateway) => {
    if (gateway._entity === 'EnergyboxThermostat' && gateway.gasSystem !== null) {
        if (gateway.gasSystem)
            return HeatingSytem.GAS;
        return HeatingSytem.ELECTRIC;
    }
    // Return NOT_AVAILABLE for unknown cases
    return global.NOT_AVAILABLE;
};
